/* eslint-disable */
export default {
  'pt-PT': {
    common: {
      NAME_HOLDER: "Nome *",
      LAST_NAME_HOLDER: "Apelido *",
      EMAIL_HOLDER: "E-mail *",
      PASS_HOLDER: "Crie uma password *",
      REPEAT_PASS_HOLDER: "Repita a password *",
      BUTTON_EMAIL_SIGN_UP: "Inicie sessão com o e-mail",

      TERMS_AND_CONDITIONS: "termos e condições",
      PRIVACY_POLICY: "política de Privacidade",

      NEWSLETTER_CONSENT: "Aceito receber emails da Time Out com as últimas notícias, eventos, ofertas e promoções de parceiros.",
      TERM_OF_USE: "Aceito os {{terms_and_conditions}} da Time Out",
      TERM_OF_USE_WITH_NEWSLETTERS: "Aceito os {{terms_and_conditions}} da Time Out, incluindo a subscrição da newsletter",

      HEADER_TITLE: "Crie uma conta Time Out",
      JOIN_FB: "Junte-se através do Facebook",
      JOIN_TW: "Junte-se através do Twitter",
      JOIN_GG: "Junte-se através do Google",
      JOIN_EM: "Junte-se através do e-mail",
      ALREADY_HAVE: "Já tem uma conta Time Out?",
      CREATE_ACCOUNT_LOG_IN: "Entrar",

      SIGN_IN_TITLE: "Iniciar sessão",
      SIGN_IN_FB: "Iniciar sessão através do Facebook",
      SIGN_IN_TW: "Iniciar sessão através do Twitter",
      SIGN_IN_GG: "Iniciar sessão através do Google",
      SIGN_IN_EM: "Iniciar sessão através do e-mail",
      YOUR_EMAIL: "O seu e-mail",
      YOUR_PASSWORD: "A sua password",
      REMEMBER: "Guardar dados",
      FORGOT: "Esqueceu-se?",
      HAVE_ACCOUNT_YET: "Ainda não tem uma conta Time Out?",
      JOIN_HERE: "Junte-se aqui",
      ALMOST_THERE: "Quase lá",

      FORGOT_HEADER: "Esqueceu a sua password?",
      FORGOT_SUBTITLE: "Sem problema. Introduza o seu e-mail abaixo - nós mandamos-lhe um link para restaurá-la.",
      SEND_LINK: "Enviar link",

      RECEIVE_EMAIL: "Obrigada. Receberá um e-mail em breve.",
      MANAGE_ACCOUNT: "Faça a gestão da sua conta",
      EDIT_DETAILS_HERE: "Pode editar os dados da sua conta aquia",
      FIRST_NAME: "Nome",
      LAST_NAME: "Apelido",
      SCREEN_NAME: "Nome de perfil",
      EMAIL: "E-mail",
      ACCOUNT_DETAILS: "Dados da conta",
      PASSWORD: "Password",
      SAVE_CHANGES: "Guardar alterações",
      UPLOAD_PIC: "Carregue uma nova fotografia de perfil",
      CHOOSE_PHOTO: "Escolha uma fotografia do seu dispositivo. Tamanho máximo: 2MB",
      CLOSE_ACCOUNT: "Fechar a minha conta",
      PASSWORD_BELOW: "Pode alterar a sua passaword abaixo",
      CURRENT_PASSWORD: "Password actual",
      NEW_PASSWORD: "Password nova",
      REPEAT_PASSWORD: "Repita a password nova",

      OOPS: "Ups,",
      ERROR_404_OCCURED: "Ocorreu um erro",
      ERROR_404_INFO: "A página foi alterada ou já não existe",
      ERROR_500_TITLE: "O servidor indica que",
      SMTH_BROKEN: "Algo não funciona",
      INTERNAL_RED: "500 Internal Server Error",
      LET_KNOW_RED: "Por favor, explique o que estava a fazer quando este erro ocorreu. Vamos resolvê-lo com a máxima brevidade. Pedimos desculpa por qualquer inconveniente.",
      ERROR_500_INFO: "what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.",

      EMAIL_ERROR: "Por favor, introduza um e-mail válido",
      PASSWORD_ERROR: "Por favor, introduza a password",
      FIRST_NAME_ERROR: "Por favor, introduza suo nome",
      LAST_NAME_ERROR: "Por favor, introduza seu sobrenome",
      TERM_OF_USE_ERROR: "Você deve concordar com nossos termos de uso",
      SIGN_IN_VALIDATION_ERROR: "E-mail ou password errados. Por favor, tente de novo",
      ACCOUNT_PASSWORDS_VALIDATION: "A password não coincide",
      WAS_IT: "Foi algo que fizemos?",
      DELETE_ACCOUNT_TEXT: "Lamentamos que esteja a pensar apagar a sua conta. O que o leva a sair?",
      DELETE_ACCOUNT: "Apagar conta",
      CANCEL: "Cancelar",

      UPDATE_PASSWORD: "Atualize sua palavra-passe",
      PASSWORD_UPDATE_SUCCESS: "A sua palavra-passe foi atualizada",
      ERROR_PASSWORD_LENGTH: "A palavra-passe deve conter pelo menos 6 caracteres",
      ERROR_ALREADY_REGISTERED: "Você já está registrado usando a inscrição por email. Faça o login usando {{email}}",

      ERROR_MISSING_SITE_PARAMETER: "Parâmetro do aplicativo obrigatório ausente: site",
    }
  }
}



// WEBPACK FOOTER //
// ./translations/pt-PT.js